import { type AuthUser } from "@/types"
import { create } from "zustand"
import { persist } from "zustand/middleware"

export type AuthState = {
  token: string | null
  user: AuthUser | null
  mfa: { challengeId: string; otpLength: number } | null
  signIn: (params: { token: string; user: AuthUser }) => void
  signOut: () => void
  startMFA: (params: { challengeId: string; otpLength: number }) => void
  clearMFA: () => void
}

export const useAuth = create<AuthState>()(
  persist(
    set => ({
      token: null,
      user: null,
      mfa: null,

      signIn: ({ user, token }) => set({ user, token }),
      signOut() {
        set({ user: null, token: null, mfa: null })
      },
      startMFA: ({ challengeId, otpLength }) => set({ mfa: { challengeId, otpLength } }),
      clearMFA: () => set({ mfa: null }),
    }),
    {
      name: "jit",
    }
  )
)
